import { useMemo } from "react";

import { format } from "date-fns";
import { useTranslation } from "react-i18next";

import { DocumentReferenceOptions } from "../../../models/document";
import { ShipmentDocument } from "../../../models/shipment.document";

interface UseDocumentsProps {
  documents?: ShipmentDocument[] | undefined;
}
export const useDocuments = ({ documents }: UseDocumentsProps) => {
  const { t: translate } = useTranslation();

  const documentsJoinned = useMemo(() => {
    if (!documents) return [];

    const docsNonCsv = documents?.filter((document) => document.fileType !== "csv") || [];
    let docsCsv = documents?.filter((document) => document.fileType === "csv") || [];

    docsCsv = docsCsv.map((doc) => {
      if (doc.name !== DocumentReferenceOptions.SHIPMENT.SSCC_CSV_UPLOADED) return doc;

      let uploadedDate = doc.uploadedAt
        ? format(new Date(doc.uploadedAt), "dd/MM/yyyy hh:mm:ss a")
        : "";

      uploadedDate = uploadedDate
        ? `${translate("on").toString().toLowerCase()} ${uploadedDate}`
        : "";

      const visualName = `${DocumentReferenceOptions.SHIPMENT.SSCC_CSV_UPLOADED} ${uploadedDate}`;

      return {
        ...doc,
        visualName,
      };
    });

    return [...docsNonCsv, ...docsCsv];
  }, [documents]);

  return {
    documentsJoinned,
  };
};
